import { restClient } from '../config/restClient'

const endpoint = id => `/api/company/candidate_list_filters/${id}`

export const getCandidateFilter = async id => {
  const response = await restClient(endpoint(id), {
    method: 'GET',
  })
  return response.data
}
